module.exports = __webpack_public_path__ + "img/customer-icon-13.54457bd2.png";